import React, { useEffect, useState } from "react";
import oembedParser from "@/utils/oembedParser";

export default function VideoTestimonial({ urlVideo }) {
  const [video, setVideo] = useState(null);
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    fetchVideo(urlVideo);
  }, []);

  async function fetchVideo(url) {
    if (url) {
      const video = await oembedParser(urlVideo);
      setVideo(video);
    }
  }

  return (
    <div className="relative aspect-video h-full w-full max-w-xs overflow-hidden bg-cover bg-no-repeat">
      {!showVideo ? (
        <img
          src={video?.thumbnail_url}
          alt={video?.title}
          className="max-h-full max-w-full cursor-pointer overflow-hidden object-cover transition duration-500 ease-in-out hover:scale-125"
          onClick={() => setShowVideo(!showVideo)}
        />
      ) : (
        <div
          className="h-full w-full object-cover "
          dangerouslySetInnerHTML={{
            __html: video?.html,
          }}
        ></div>
      )}
    </div>
  );
}
